import kyruusTheme from '@kyruus/ui-theme';
import { PMCConfig } from '@kyruus/types';
import { shouldRenderDirectBookInDrawer } from 'Common/config/utils';

const SCHEDULE_DRAWER_SCREEN_SIZES = {
  db_screen_large: '10000px',
  db_screen_medium: '10000px',
  db_screen_small: '10000px',
  db_screen_xsmall: '10000px'
};
interface GetCustomerBiomeThemeProps {
  customerConfig?: PMCConfig;
  isCancelOrManageApptFlow?: boolean;
}
export const getCustomerKyruusTheme = ({
  customerConfig,
  isCancelOrManageApptFlow = false
}: GetCustomerBiomeThemeProps) => {
  if (!customerConfig) {
    return kyruusTheme;
  }
  const { theme: customerThemeConfig = {} } = customerConfig;
  /* 
   If the drawer feature flag is enabled and the current flow is not a cancel or manage appointment flow,
   set the drawer screen sizes to a large value to prevent the drawer from rendering desktop content.
  **/
  const themeToRenderScheduleInDrawer =
    !isCancelOrManageApptFlow && shouldRenderDirectBookInDrawer(customerConfig)
      ? SCHEDULE_DRAWER_SCREEN_SIZES
      : {};
  return {
    ...kyruusTheme,
    ...customerThemeConfig,
    ...themeToRenderScheduleInDrawer
  };
};
